var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"structure-node-children"},[_vm._l((_vm.nodes),function(childElement){return [_c('StructureNode',{key:childElement.id,attrs:{"element":childElement,"depth":_vm.depth}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }